module.exports = __webpack_public_path__ + "img/9788996224242.c5b48030.jpg";